import React, { useState } from 'react';

interface EndTurnButtonProps {
  isCurrentPlayerTurn: boolean;
  onEndTurn: () => Promise<void>;
  disabled?: boolean;
}

export const EndTurnButton: React.FC<EndTurnButtonProps> = ({
  isCurrentPlayerTurn,
  onEndTurn,
  disabled = false,
}) => {
  const [isEnding, setIsEnding] = useState(false);

  const handleEndTurn = async () => {
    if (!isCurrentPlayerTurn || disabled || isEnding) return;

    setIsEnding(true);
    try {
      await onEndTurn();
    } catch (error) {
      console.error('Failed to end turn:', error);
    } finally {
      setIsEnding(false);
    }
  };

  if (!isCurrentPlayerTurn) {
    return (
      <button
        disabled
        className="w-full py-3 px-4 bg-gray-200 text-gray-500 rounded-lg font-semibold cursor-not-allowed"
      >
        Not Your Turn
      </button>
    );
  }

  return (
    <button
      onClick={handleEndTurn}
      disabled={disabled || isEnding}
      className={`w-full py-3 px-4 rounded-lg font-semibold transition-colors ${
        disabled || isEnding
          ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
          : 'bg-blue-600 text-white hover:bg-blue-700 active:bg-blue-800'
      }`}
    >
      {isEnding ? 'Ending Turn...' : 'End Turn'}
    </button>
  );
};